import React, { useState }from 'react';
import Card from '../../components/card.component';
import {
  Row,
  Col,
} from 'react-bootstrap';
import draftToHtml from 'draftjs-to-html';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import boletinesFunction from './boletines.function';
import ClienteComponent from '../../components/clientes.component';
import MasterComponent from '../../components/master.component';
import notification from '../../components/notification.component';

const Boletines = () => {

  const initialValues = {
    filtro_todos: true,
    filtro_clientes: false,
    filtro_master_guia: false,
  }
  const [filtros, setFiltros] = useState(initialValues);
  const [filterData, setFilterData] = useState([]);
  const [pending, setPending] = useState(false);
  const [asunto, setAsunto] = useState('');
  const [editorState, setEditorState] = useState(
    EditorState.createEmpty()
  );

  const handleFiltroChange = (e) => {
    const value = e.target.value;
    const resultado = {
      filtro_todos: value === 'filtro_todos' ? true : false,
      filtro_clientes: value === 'filtro_clientes' ? true : false,
      filtro_master_guia: value === 'filtro_master_guia' ? true : false,
    };
    setFiltros(resultado);
  }

  const resetData = () => {
    setFilterData([]);
    setFiltros(initialValues);
    setEditorState(EditorState.createEmpty());
    setAsunto('');
  }

  const setValues = (e) => {
    setAsunto(e.target.value);
  }

  const registrarBoletin = () => {
    const toHtmlContent = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    const filter_use = getFilter();
    const data = {
      filter_use: filter_use,
      filter_data: JSON.stringify(filterData),
      content_html_message: toHtmlContent.toString(),
      subject: asunto,
    }

    let passed = true;
    if (filter_use !== 'filtro_todos') {
      if (!filterData.length) {
        passed = false;
      }
    }

    if (asunto.trim() === '') {
      passed = false;
    }

    if (passed) {
      setPending(true);
      boletinesFunction.register(data).then((response) => {
        if (response.data.envio_email_boletin) {
          notification.success();
          resetData();
        } else {
          notification.warning('El boletín no fue enviado por un error');
        }
        setPending(false);
      })
    } else {
      notification.warning('Complete la información antes de enviar');
    }
  }

  const gestorSelector = (data) => {
    const filter_data = data.selectedRows.map((e) => e.id);
    setFilterData(filter_data);
  }
  
  const getFilter = () => {
    let resultado = 'filtro_todos';
    const filtrosKeys = Object.keys(filtros);
    filtrosKeys.forEach(element => {
      if (filtros[element]) {
        resultado = element
      }
    });
    if(resultado === 'filtro_todos') {
      setFilterData([]);
    } 
    return resultado;
  }

  return (
    <>
    <Row>
      <Col>
      <Card>
        <div className="d-flex justify-content-between">
          <div>
            <small>Filtro</small>
            <div>
            <div className="form-check form-check-inline">
              <input onChange={handleFiltroChange} className="form-check-input" type="radio" name="filtros" value="filtro_todos" checked={filtros.filtro_todos}/>
              <label className="form-check-label" forhtml="inlineRadio1">Todos los clientes</label>
            </div>
            <div className="form-check form-check-inline">
              <input onChange={handleFiltroChange} className="form-check-input" type="radio" name="filtros" value="filtro_clientes"  checked={filtros.filtro_clientes}/>
              <label className="form-check-label" forhtml="inlineRadio2">Filtrar clientes</label>
            </div>
            <div className="form-check form-check-inline">
              <input onChange={handleFiltroChange} className="form-check-input" type="radio" name="filtros" value="filtro_master_guia"  checked={filtros.filtro_master_guia}/>
              <label className="form-check-label" forhtml="inlineRadio3">Guia master</label>
            </div>
            </div>
          </div>

          <div className="d-flex align-items-end">
             {/* <button 
               type="button"
               className="btnx btnx-warn"
              >
                 Boletines enviados
             </button> */}
          </div>
        </div>
      </Card>
      </Col>
    </Row>

   {filtros.filtro_clientes || filtros.filtro_master_guia ? 
    <Row className="mt-3">
      <Col>
      <Card>
        <div>
          <small>Seleccione filtro</small>
          <div>
           {filtros.filtro_clientes ? 
            <ClienteComponent
              onSeleccting={(data, tipo) => gestorSelector(data, tipo)}
              filtre={filtros.filtro_clientes}
              tipo="filtro_clientes"
            />
            : filtros.filtro_master_guia ?
            <MasterComponent 
              onSeleccting={(data, tipo) => gestorSelector(data, tipo)}
              filtre={filtros.filtro_master_guia}
              tipo="filtro_master_guia"
            />
           : null }
          </div>
        </div>
      </Card>
      </Col>
    </Row>
    : null}

    <Row className="mt-3">
      <Col>
      <Card className="card-box-text">
        <div>
          <small>Contenido del mensaje</small>
          <div>
            <input onChange={(e) => setValues(e)} type="text" className="form-control input-border mb-1" name="asunto" placeholder="Asunto del boletín" value={asunto}/>
            <Editor
              editorState={editorState}
              onEditorStateChange={editorState => setEditorState(editorState)}
              editorClassName="editor-class"
              wrapperClassName="wrapper-class-x"
              toolbar ={{
                options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'image', 'remove', 'history'],
              }}
            />
          </div>
        </div>
      </Card>
      </Col>
    </Row>

    <Row className="mt-3">
      <Col>
      <Card>
        <div>
          <button 
            type="button"
            className="btnx btnx-warn"
            onClick={registrarBoletin}
            disabled={pending}
          >
              Enviar boletín
          </button>
        </div>
      </Card>
      </Col>
    </Row>
    </>
  )
}

export default Boletines;